import { Component, effect } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormControl, ReactiveFormsModule,} from '@angular/forms';

import { TrimmedSession } from '../../../shared/models/session.model';
import { CouponFormat } from '../../../shared/models/couponFormat.model';
import { Plan } from '../../../shared/models/plan.model';
import { PromoService } from '../../../shared/promo.service';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';

@Component({
  selector: 'app-dynamic-payment-component-coupon-form',

  template: `
    <div appearance="outline" floatLabel="always">
      <div class="input-group">
        <input aria-label="sets coupon code with text input" matInput type="text" class="form-control d-inline-block" name="coupon" 
          [formControl]="couponControl" placeholder="Enter promo code" (keydown.enter)="checkCouponCode()">    
        <button aria-label="Apply coupon" class="btn btn-outline-secondary d-inline-block" matSuffix mat-icon-button (click)="checkCouponCode()">Apply</button>
      </div>
    </div>
    @if(couponErrorFlag){
      <p class="ps-2plus coupon-highlight-fail">*Not a Valid coupon</p>
    }
    @if(this.coupon){
      <p class="ps-2plus coupon-highlight-pass">
        {{this.coupon.message}}
        <img class="" src="assets/Icons/refresh.svg" (click)="resetFromCoupon()" clickable *ngIf="couponErrorFlag && realCouponExists">
      </p>
    }
  `,
  styleUrls: ['./dynamic-payment-component-coupon-form.component.scss'],
  standalone: true,
  imports: [ 
    NgIf, 
    ReactiveFormsModule
  ],
})
export class DynamicPaymentComponentCouponFormComponent {

  couponControl = new FormControl('');

  realCouponExists: boolean = false;

  //need Plan and generic session details
  couponString : string = '';

  get plan(): Plan {
    return this.directSessionLogic.planSelectedSignal();
  }
  get coupon(): CouponFormat {
    return this.promoService.couponSignal();
  }
  get couponErrorFlag(): boolean {
    return this.promoService.couponErrorFlagSignal();
  }
  get trimmedSession(): TrimmedSession {  
    return this.directSessionLogic.trimmedSessionSignal();
  }

  constructor(
    public directSessionLogic: DirectSessionLogicService,
    public promoService: PromoService,
  ){

    effect(() => {
      this.couponString = this.promoService.couponInputSignal();
      this.couponControl.setValue(this.couponString);
    });

    //if this session has a coupon code entered from session, set the coupon control to that value
    if(this.directSessionLogic.planSelectedSignal() !== undefined && this.promoService.couponInputSignal() !== "") {
      this.resetFromCoupon();
    }
  }


  async checkCouponCode(){

    let currentCode = this.couponControl.value ?? "";
    if(currentCode != null || currentCode != "" || currentCode != undefined){
      this.promoService.updateCouponInputSignal(currentCode);
      let plan = this.directSessionLogic.planSelectedSignal();
      await this.promoService.validateCouponInputSignal(plan);
    }
    this.directSessionLogic.recalculateTotalCostInSessionSignal();
  }

  isCouponFormat( obj: any): obj is CouponFormat{
    return obj && typeof obj.message === 'string' && obj.message.length > 0;
  }

  resetFromCoupon(){
    if( this.couponString !== '' && this.coupon?.code != undefined ) {
      this.couponControl.setValue(this.coupon.code); //value from coupon signal
    }
    else if(this.couponString !== ''){
      this.couponControl.setValue(this.promoService.couponInputSignal()); //value from couponCode signal
    }
    this.checkCouponCode();
    this.directSessionLogic.recalculateTotalCostInSessionSignal();
  }

}
